import React from 'react';

import Checkbox from 'material-ui/Checkbox';
import {
    ListItem,
    ListItemText,
    ListItemSecondaryAction
} from 'material-ui/List';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import Console from '../../../../lib/debug';

const iconStyles = {
    fontSize: 20
};

export default class MDFilterItem extends React.Component {
    handleSelect = () => {
        this.props.onSelect(this.props.item);
    };

    render() {
        Console.render('designer.MDFilterItem');
        let item = this.props.item;
        let isSelected = this.props.isSelected;

        return (
            <ListItem
                role={undefined}
                className={`MegaDrop-item filter${
                    isSelected ? ' selected' : ''
                }`}
                dense
                button
                onClick={this.handleSelect}
            >
                <Checkbox
                    className="MegaDrop-checkbox"
                    icon={<CheckBoxOutlineBlankIcon style={iconStyles} />}
                    checkedIcon={<CheckBoxIcon style={iconStyles} />}
                    checked={isSelected}
                    tabIndex={-1}
                    disableRipple
                />
                <ListItemText className="MegaDrop-title" primary={item.title} />
                <ListItemSecondaryAction className="MegaDrop-item-chip">
                    <span className="chip">{item.exercises.length}</span>
                </ListItemSecondaryAction>
            </ListItem>
        );
    }
}
